import {observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class QuantidadePercentualSolicitacaoExcecaoDivisaoDepartamentoStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable departamentos;
    @observable dadosNaoTratados;
    @observable activeTab;

    constructor() {
        this.indicadorService = new IndicadorService();

        this.activeTab = '1';
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findQuantidadePercentualSolicitacaoExcecaoDivisaoDepartamento(filtro).then(response => {
            const divisoesAgrupadas = _.groupBy(response.data, (d) => d.divisao);
            const divisoes = Object.keys(divisoesAgrupadas);
            const departamentosAgrupados = _.groupBy(response.data, (d) => d.departamento);
            const departamentos = Object.keys(departamentosAgrupados);

            let dados = [];
            _.forEach(divisoes, (divisao) => {
                let dado = { nome: divisao };

                const divisoesDepartamentos = divisoesAgrupadas[divisao];

                _.forEach(divisoesDepartamentos, (divisaoDepartamento) => {
                    dado = { ...dado, [divisaoDepartamento.departamento]: divisaoDepartamento.quantidade };
                });

                dados = [ ...dados, dado ];
            });

            this.dadosNaoTratados = response.data.map((dado) => ({
                nome: `${dado.divisao} + ${dado.departamento}`,
                "Quantidade": dado.quantidade
            }));

            this.departamentos = departamentos;
            this.dados = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }
}
